import { render, staticRenderFns } from "./FundBalances.vue?vue&type=template&id=3932a3bd&"
import script from "./FundBalances.vue?vue&type=script&lang=js&"
export * from "./FundBalances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports